module.exports = __webpack_public_path__ + "Flag-32.9d120c63379451efc294b9077cf947f4.svg";